import { type ReactNode, useState } from "react"

import { useIsInspectorTabActive } from "~/components/design-system/pages/internal/inspectorTab"

/**
 * One tab's content inside an inspector whose page declared tabs with `useInspectorTab`. A tab
 * mounts the first time it is opened, so a tab nobody opens never fetches. From then on it stays
 * MOUNTED but hidden, so drafts and scroll position survive a switch. Each card still needs an
 * explicit height (pages/README.md § Every inspector item needs an explicit height).
 *
 * Approved surface: design-system/APPROVED.md.
 */
const InspectorTabPanel = ({ tabId, children }: { tabId: string; children: ReactNode }) => {
  const isActive = useIsInspectorTabActive(tabId)
  const [opened, setOpened] = useState(isActive)
  if (isActive && !opened) setOpened(true)
  return (
    <div hidden={!isActive} inert={!isActive} className="flex flex-col gap-5 [&>*]:shrink-0">
      {opened && children}
    </div>
  )
}

export default InspectorTabPanel
